<template>
  <div class="merchantDetails">
    <el-card shadow="never">
      <div class="step-view">
        <el-steps :active="stepIndex" align-center>
          <el-step title="填写激活码"></el-step>
          <el-step title="创建门店管理员"></el-step>
          <el-step title="填写门店信息"></el-step>
          <el-step title="设置费率"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>
    </el-card>
    <infoForm :isChain="isChain" v-if="stepIndex === 3" :read-only="readOnly"
        :is-edit="isEdit"
        :id="merchantId"
        :submit-loading="buttonLoading"
        @submit="editInfo"
        @resetDisabled="readOnly = true" :stepIndex="stepIndex"></infoForm>
    <rateForm :isChain="isChain" v-if="stepIndex === 4" :id="FMerchantId" @submit="submitRate" style="margin: 20px 0;" :is-add="true"></rateForm>
  </div>
</template>

<script>
import infoForm from '../components/infoForm2'
import rateForm from '../components/rateForm'
import { updateIntellectMerchant, intellectRegister } from '@/api/merchant'
import { chainShopRelativeMerchant } from '@/api/merchant-info'
import qs from 'qs'
import md5 from 'js-md5'
export default {
  name: 'MerchantDetails',
  components: {
    infoForm,
    rateForm
  },
  data () {
    return {
      stepIndex: 3,
      activeName: 'info',
      buttonLoading: false, // 按钮加载中
      readOnly: '',
      isEdit: '',
      merchantId: '', // 商户id
      hasGetRate: false // 是否已加载费率信息
    }
  },
  watch: {
    activeName (val) {
      if (val === 'rate' && !this.hasGetRate) {
        this.hasGetRate = true
      }
    }
  },
  created () {
    console.log('activated:', this.$route.query)
    console.log(JSON.stringify(this.$route.query) !== '{}')
    if (JSON.stringify(this.$route.query) !== '{}') {
      const query = this.$route.query
      // if (this.merchantId !== query.id) {
      this.merchantId = query.id
      this.readOnly = query.readOnly === '1'
      this.isEdit = query.isEdit === '1'
      localStorage.setItem('merchantDetailsQuery', JSON.stringify(query))
      // }
    } else {
      if (localStorage.getItem('merchantDetailsQuery') !== '') {
        const query = JSON.parse(localStorage.getItem('merchantDetailsQuery'))
        this.merchantId = query.id
        this.readOnly = query.readOnly === '1'
        this.isEdit = query.isEdit === '1'
      }
    }
    if (this.activeName === 'info') {
      this.hasGetRate = false
    }
  },
  methods: {
    async chainShopRelativeMerchant (merchantId) {
      try {
        await chainShopRelativeMerchant({
          chainMerchantId: merchantId,
          chainShopId: this.$route.query.shopId
        })
        this.$router.push({ path: '/Merchant/MerchantManage/AllMerchant' })
      } catch (e) {
        console.log(e)
      }
    },
    async intellectRegister (para) {
      try {
        const that = this
        const res = await intellectRegister(para)
        if (res.result_cde === '0') {
          that.FMerchantId = res.data.merchantId
          await this.chainShopRelativeMerchant(res.data.merchantId)
          that.$message({
            message: res.result_msg,
            type: 'success'
          })
        } else {
          that.$message({
            showClose: true,
            message: res.result_msg,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.buttonLoading = false
      }
    },
    async updateIntellectMerchant (param) {
      try {
        const that = this
        const data = await updateIntellectMerchant(param)
        if (data.result_cde === '0') {
          that.$message({
            message: data.result_msg,
            type: 'success'
          })
          that.$router.push({ path: '/Merchant/SoftwareMerchant/chainShopManager' })
        } else {
          that.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.buttonLoading = false
      }
    },
    /**
             * @description 编辑商户信息
             * @param  {number} data 组件提交的数据
             */
    editInfo (data) {
      let param = JSON.parse(JSON.stringify(data))
      const that = this
      const pw = param.userPassword
      if (pw) {
        param.userPassword = md5(pw)
      }
      param = Object.assign({}, param, { merchantId: that.merchantId })
      // 删除不需提交的参数
      delete param.headShopMerchantId
      delete param.username
      delete param.statusDesc
      delete param.reportConfigId
      // delete param.credentialType;

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.buttonLoading = true
        param = qs.stringify(this.dismissBlank(param))
        // 没有merchantId走注册流程 有走更新流程
        if (!that.merchantId) {
          this.intellectRegister(param)
        } else {
          this.updateIntellectMerchant(param)
        }
        that.buttonLoading = false
      })
    },
    /**
             * @description 删除对象中字符串的空格
             * @param  {number} params 目标对象
             */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !['legalName', 'holder'].includes(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      console.log(params)
      return params
    }
  }
}
</script>

<style scoped>
    .merchantDetails {
        padding: 20px
    }
</style>
<style>
    .merchantDetails .el-tabs__item{
        font-size: 18px;
    }
</style>
